import { isCPAuthRoutePath } from '@clientportal/routing-layer/utils/auth-route.utils'

import type { SupportChatRouteLike, SupportChatSurfaceKey } from '../types/support-chat-permission.types'

const routeNameString = (name: SupportChatRouteLike['name']): string | null => (typeof name === 'string' ? name : null)

export function isCoursesLibraryRoute(path: string, name: string | null): boolean {
  if (
    path === '/courses' ||
    path === '/courses/' ||
    path.startsWith('/courses/my-library') ||
    path.startsWith('/courses/my-courses') ||
    path.startsWith('/courses/search')
  ) {
    return true
  }

  if (
    name === 'my-library' ||
    name === 'courses-my-library' ||
    name === 'courses-products-library' ||
    name === 'clientportal-courses-my-courses' ||
    name === 'courses' ||
    name === 'courses-search'
  ) {
    return true
  }

  return false
}

function isMembershipSurface(path: string, name: string | null): boolean {
  if (isCoursesLibraryRoute(path, name)) {
    return false
  }
  return path.startsWith('/courses') || Boolean(name?.startsWith('courses-'))
}

function isAffiliateSurface(path: string): boolean {
  return path === '/affiliates' || path.startsWith('/affiliates/')
}

function isCommunitiesSurface(path: string, name: string | null): boolean {
  return path.startsWith('/communities') || Boolean(name?.startsWith('communities-'))
}

/**
 * Maps the current clientportal route to a portal `chatWidgetSettings.permissions` key.
 * Order: auth (none) → courses library (none) → `/courses` / courses-* → affiliates → communities → home.
 */
export function resolveSupportChatPermissionKey(route: SupportChatRouteLike): SupportChatSurfaceKey | null {
  const path = route.path || ''
  if (!path || isCPAuthRoutePath(path)) {
    return null
  }

  const name = routeNameString(route.name)
  if (isCoursesLibraryRoute(path, name)) {
    return null
  }
  if (isMembershipSurface(path, name)) {
    return 'membership'
  }
  if (isAffiliateSurface(path)) {
    return 'affiliate'
  }
  if (isCommunitiesSurface(path, name)) {
    return 'communities'
  }
  return 'home'
}
